import { render } from "./CreateOrUpdateRoleModal.vue?vue&type=template&id=1e7f0ef2&ts=true"
import script from "./CreateOrUpdateRoleModal.vue?vue&type=script&lang=ts"
export * from "./CreateOrUpdateRoleModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__